import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { clientMaster } from 'src/app/Models/BasicForms/clientMaster';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-client-drawer',
  templateUrl: './client-drawer.component.html',
  styleUrls: ['./client-drawer.component.css']
})

export class ClientDrawerComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: clientMaster;

  constructor(public _apiService: ApiService, private notificationService: NzNotificationService) { }

  ngOnInit(): void { }

  isSpinning = false;
  logtext: string = "";
  save(addNew: boolean): void {



    var isOk = true;

    if (this.data.NAME != undefined) {
      if (this.data.NAME.trim() == '') {
        isOk = false;
        this.notificationService.error("Please Enter Valid Name", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Name", "");
    }

    if (this.data.EMAIL_ID != undefined) {
      if (this.data.EMAIL_ID.trim() != '') {
        if (!this.checkEmailIDIsValidOrNot(this.data.EMAIL_ID.trim())) {
          isOk = false;
          this.notificationService.error("Please Enter Valid Email ID", "");
        }
      } else {
        isOk = false;
        this.notificationService.error("Please Enter Valid Email ID", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Email ID", "");
    }

    if (this.data.MOBILE_NO != undefined) {
      if (this.data.MOBILE_NO != null) {
        if (!this.checkLengthOfMobileNo(this.data.MOBILE_NO)) {
          if (!this.checkMobileNoIsValidOrNot(this.data.MOBILE_NO)) {
            isOk = false;
            this.notificationService.error("Please Enter Valid Mobile No.", "");
          }
        } else {
          isOk = false;
          this.notificationService.error("Please Enter Valid Mobile No.", "");
        }
      } else {
        isOk = false;
        this.notificationService.error("Please Enter Valid Mobile No.", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Mobile No.", "");
    }

    if (this.data.INDUSTRY_NAME != undefined) {
      if (this.data.INDUSTRY_NAME.trim() == '') {
        isOk = false;
        this.notificationService.error("Please Enter Valid Industry's Name", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Industry's Name", "");
    }

    if (this.data.INDUSTRY_ADDRESS != undefined) {
      if (this.data.INDUSTRY_ADDRESS.trim() == '') {
        isOk = false;
        this.notificationService.error("Please Enter Valid Industry's Address", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Industry's Address", "");
    }

    if (this.data.INDUSTRY_CITY != undefined) {
      if (this.data.INDUSTRY_CITY.trim() == '') {
        isOk = false;
        this.notificationService.error("Please Enter Valid Industry's City", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Industry's City", "");
    }

    if (this.data.INDUSTRY_PINCODE != undefined) {
      if (this.data.INDUSTRY_PINCODE != null) {
        if (!this.checkLengthOfPincode(this.data.INDUSTRY_PINCODE)) {
          if (!this.checkPincodeIsValidOrNot(this.data.INDUSTRY_PINCODE)) {
            isOk = false;
            this.notificationService.error("Please Enter Valid Pincode", "");
          }
        } else {
          isOk = false;
          this.notificationService.error("Please Enter Valid Pincode", "");
        }
      } else {
        isOk = false;
        this.notificationService.error("Please Enter Valid Pincode", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Pincode", "");
    }

    if (this.data.BILLING_MODE == undefined) {
      isOk = false;
      this.notificationService.error("Please Select Billing Mode", "");
    }

    if (isOk) {
      this.isSpinning = true;

      if (!this.data.ID) {
        this._apiService.createClient(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Client Added Successfully", "");

            if (!addNew) {
              this.drawerClose();

              this.logtext = 'Save & Close - Client Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Client Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });

            } else {
              this.data = new clientMaster();

              this.logtext = 'Save & New - Client Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Client Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });
            }
            this.isSpinning = false;

          } else {
            this.notificationService.error("Failed to Add Client", "");
            this.logtext = 'Save & Close - Client Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Client Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });

      } else {
        this._apiService.updateClient(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Client Updated Successfully", "");
            this.logtext = 'Update & Close - Client Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Client Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });

            this.isSpinning = false;
            this.drawerClose();

          } else {
            this.notificationService.error("Failed to Update Client", "");
            this.logtext = 'Update & Close - Client Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Client Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });
      }
    }
  }

  checkEmailIDIsValidOrNot(EmailID: string) {
    const expression = /[a-z0-9._%+-]+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
    return expression.test(String("" + EmailID).toLowerCase());
  }

  checkMobileNoIsValidOrNot(mobileNo: number) {
    const expression = /[6-9][0-9]{9}$/;
    return expression.test(String("" + mobileNo).toLowerCase());
  }

  checkPincodeIsValidOrNot(pincode: number) {
    const expression = /[1-9]{1}[0-9]{5}$/;
    return expression.test(String("" + pincode).toLowerCase());
  }

  checkLengthOfPincode(pincode: number) {
    var len = Math.ceil(Math.log(pincode + 1) / Math.LN10);

    if (len == 6) {
      return false;

    } else {
      return true;
    }
  }

  checkLengthOfMobileNo(mobileNo: number) {
    var len = Math.ceil(Math.log(mobileNo + 1) / Math.LN10);

    if (len == 10) {
      return false;

    } else {
      return true;
    }
  }

  close(clientMasterPage: NgForm) {
    this.drawerClose();
    this.resetDrawer(clientMasterPage);
  }

  resetDrawer(clientMasterPage: NgForm) {
    this.isSpinning = false;
    clientMasterPage.form.reset();
    this.data = new clientMaster();
  }
}
